'use client'
import GridRow from '@/frontend/legacy/components/Grid/Row'
import GridCol from '@/frontend/legacy/components/Grid/Col'
import Link from 'next/link'
import { toast } from 'sonner'

export const Form = () => {
  async function onSubmit(event) {
    event.preventDefault()
    const formData = Object.fromEntries(new FormData(event.target).entries())
    await fetch('/api/send', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.mail,
        message: formData.message,
        datasecurity: formData.datasecurity,
      }),
    }).then((res) => {
      if (res.ok) {
        toast.success('Nachricht erfolgreich verschickt')
      } else {
        toast.error(
          'Nachricht konnte nicht verschickt werden. Melde dich gerne einfach per E-Mail an hello@annkatrinmerk.com',
        )
      }
    })
  }

  return (
    <>
      <form onSubmit={onSubmit}>
        <GridRow>
          <GridCol size={`xs-12 m-6`}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input type="text" name="name" required placeholder="Gib deinen Vornamen ein" />
            </div>
          </GridCol>
          <GridCol size={`xs-12 m-6`}>
            <div className="form-group">
              <label htmlFor="mail">E-Mail</label>
              <input
                type="email"
                name="mail"
                required
                placeholder="Hinterlege bitte deine E-Mail"
              />
            </div>
          </GridCol>
          <GridCol size={`xs-12`}>
            <div className="form-group">
              <label htmlFor="message">Nachricht</label>
              <textarea name="message" required placeholder="Deine Nachricht an mich" />
            </div>
          </GridCol>
          <GridCol size={`xs-12`}>
            <div className="form-group">
              <div className="checkbox">
                <input type="checkbox" name="datasecurity" required />
                <label htmlFor="datasecurity">
                  <span>Ich habe die</span>
                  <Link href="/datenschutz" title="Zur Datenschutzerklärung">
                    Datenschutzerklärung
                  </Link>
                  <span>gelesen und bin damit einverstanden.</span>
                </label>
              </div>
            </div>
          </GridCol>
          <GridCol size={`xs-12`}>
            <div className="form-group">
              <div className={`cta-container alignment-right`}>
                <button type="submit" className="cta layout-0">
                  Abschicken
                </button>
              </div>
            </div>
          </GridCol>
        </GridRow>
      </form>
    </>
  )
}

export default Form
